import { Link } from "react-router-dom";
import "./About.scss";
import aboutFeature from "../../assets/about/about-feature.webp";
import {
  WhiskAndBowlIcon,
  PlateIcon,
  OilFreeIcon,
  OvenIcon,
  HandsIcon,
  CakeIcon,
} from "../../assets/global/Icons";

function About() {
  return (
    <div className="wrapper">
      <h1>Welcome to Connie's Cakerie</h1>
      <div className="flex-container">
        <img
          src={aboutFeature}
          alt="Connie cuts a celebration cake"
          className="page-feature-img"
        />
        <div className="page-feature-desc">
          <p>
            Welcome! I'm Connie, the founder and cake decorator behind Connie’s
            Cakerie. I'm a small, woman-owned bakery in Mountain View, proudly
            serving the Bay Area since July 2016. After taking a couple cake
            decorating classes at a craft store, I found myself baking for
            friends and family before ultimately expanding to customers and
            corporate clients across Silicon Valley.
          </p>
          <p>
            My cakes are made entirely from scratch using quality,
            easy-to-pronounce ingredients – no box mix starters or pudding
            hacks. I believe taste matters just as much as appearance. I offer a
            range of custom, hand-crafted desserts – all designed to match your
            event’s theme and vision. Whether you’re planning a birthday,
            shower, wedding, or corporate event, I hope to create sweets that
            look as beautiful as they taste.
          </p>
          <p>
            In addition to custom desserts, I also teach hands-on decorating
            workshops for both individuals and groups. From beginner-friendly
            classes to corporate team-building events, my goal is to make
            decorating approachable and fun for everyone.
          </p>
          <p>
            Thank you for supporting your local bakery and allowing me to be a
            part of your special moments. I look forward to taking your next
            order!
          </p>
          <p>
            Cakes & Cheers,
            <br />
            Connie
          </p>
        </div>
      </div>

      <hr />

      <h2>What makes my bakery special</h2>
      <div className="flex-container">
        <div className="special-item">
          <WhiskAndBowlIcon className="special-item__img" />
          <strong className="special-item__heading">Baked from scratch</strong>
        </div>
        <div className="special-item">
          <PlateIcon className="special-item__img" />
          <strong className="special-item__heading">
            Friendly to <br /> dietary restrictions
          </strong>
        </div>
        <div className="special-item">
          <OilFreeIcon className="special-item__img" />
          <strong className="special-item__heading">
            No preservatives <br /> or trans fat
          </strong>
        </div>
        <div className="special-item">
          <OvenIcon className="special-item__img" />
          <strong className="special-item__heading">Made to order</strong>
        </div>
        <div className="special-item">
          <HandsIcon className="special-item__img" />
          <strong className="special-item__heading">
            Personalized <br /> customer service
          </strong>
        </div>
        <div className="special-item">
          <CakeIcon className="special-item__img" />
          <strong className="special-item__heading">Any custom design</strong>
        </div>
      </div>

      <hr />

      <h2>Interested in working with me?</h2>
      <div className="flex-container margin-top-lg">
        <div className="work-item">
          <Link to="/order">
            <button className="btn">Place an order</button>
          </Link>
          <p className="work-item__text">
            Place an order for your next special occasion!
          </p>
        </div>
        <div className="work-item">
          <Link to="/classes">
            <button className="btn">Sign up for a class</button>
          </Link>
          <p className="work-item__text">
            Take your skills to the next level with our interactive decorating
            classes.
          </p>
        </div>
      </div>

      <hr />

      <h2>Still have questions?</h2>
      <div className="center">
        <Link to="/faqs">
          <button className="btn">View FAQs</button>
        </Link>
        <p className="margin-top-sm">
          Head over to the FAQs page for answers to commonly asked questions
          about ordering, payments, delivery, and dessert care.
        </p>
      </div>
    </div>
  );
}

export default About;
